import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
   <footer className="container-fluid main-footer bg-light border-top py-3 ">
  <div className="container-fluid">
    <div className="d-flex justify-content-between align-items-center">
      <span className="text-dark">
        &copy; 2025. BULK SMS. Tous droits réservés.
      </span>
      <span className="text-muted">
        Créé par:{" "}
        <Link 
          to="https://minerve-tech.com" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-primary text-decoration-none"
        >
          MINERVE-TECH
        </Link>
      </span>
    </div>
  </div>
</footer>
  );
}